import axios from "axios";


export const BASE_CLIENT_URL = 'https://i-chest.com';

export const BASE_URL = 'https://api.i-chest.com/';

export const myAxios = axios.create({
    baseURL: BASE_URL,
}); 